<template>


  <v-row justify-center>
    <v-dialog v-model="dialog" persistent max-width="900px" @keydown.esc="chiudi(false)" scrollable>

      <v-card pa-0>
        <v-card-title class="pa-0">
          <v-toolbar color="light-grey darken-2" dense text style="border-bottom:1px solid grey;">
            <v-btn icon @click="chiudi(false)">
              <v-icon>close</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <h1 style="font-size: 15px; letter-spacing: 1px;" class="mb-2 mt-2 font-weight-bold ">
              {{ getMsg }}
            </h1>
            <v-btn v-if="visBottoneConferma" color="green" dark @click="accettaTermini" :loading="attesa">
              <v-icon class="mr-2">done_outline</v-icon>Conferma
            </v-btn>
            <v-spacer></v-spacer>
          </v-toolbar>
        </v-card-title>
        <v-card-text style="height: 800px;" class="pa-0">

          <div style="height:100%; text-align:center; background:white;">

            <iframe v-if="pathPdf" :src="pathPdf" width="100%" height="100%"
              style="overflow:scroll !important;">Caricamento....</iframe>
            <span style="font-size:20px;">{{ msgErrore }}</span>
          </div>

        </v-card-text>

      </v-card>
    </v-dialog>

    <!-- Dialog termini -->
    <v-dialog v-model="dialogTermini" max-width="500px" persistent>
      <div style="background:white;" class="pa-2">
        <v-alert :value="true" type="info" outline>
          Cliccando su CONFERMA dichiari di aver letto e accettato i termini e specifiche della conferma
          ordine nr.
          {{ prog }}.
          <br><br>
          Verrà inviata una mail di conferma a {{ getMail }}.
          <br><br>
          Vuoi continuare ?
        </v-alert>

        <div style="text-align:right;">
          <v-btn color="primary" dark @click="conferma" :loading="attesa">
            <v-icon class="mr-2">done_outline</v-icon>Si
          </v-btn>

          <v-btn v-if="!confermato" color="primary" dark @click="esciDialogTermini" :loading="attesa">
            <v-icon class="mr-2">close</v-icon>No
          </v-btn>
        </div>
      </div>
    </v-dialog>

  </v-row>

</template>

<script>
import { save_confermeOrdini } from "@/api/api.ordini.js";

export default {
  props: {
    dialog: { type: Boolean, required: true },
    confermato: { type: Boolean, required: true },
    fuoriTempo: { type: Boolean, default: false, required: false },
    prog: { type: Number, default: 0, required: true },
    codCliente: { type: String, default: "", required: true },
    numOrdine: { type: String, default: "" },
    rif: { type: String, default: "" },
    role: { type: String, default: "" },
    ordineConferma: { type: Boolean, default: false },
    serie: { type: String, default: "" }
  },

  data: () => ({
    pathPdf: "",
    attesa: false,
    msgErrore: "",
    dialogTermini: false
  }),

  methods: {
    async caricaDati() {
      this.pathPdf = "";
      this.msgErrore = "";
      if (!this.dialog) return;

      this.pathPdf = await this.getPercorso();
      console.log(this.pathPdf);
    },

    async getPercorso() {
      let base = this.$load.getUrlUserFile();
      let ts = Date.now();
      let urlOrdini = `${base}/Ordini/${this.codCliente}/${this.prog}.pdf?ts=${ts}`;
      let urlConferme = `${base}/Conferme/${this.codCliente}/${this.prog}.pdf?ts=${ts}`;

      if (this.ordineConferma) return urlOrdini;
      return urlConferme;
    },

    accettaTermini() {
      this.dialogTermini = true;
    },

    async conferma() {
      this.esciDialogTermini();

      this.attesa = true;

      try {
        let par = {
          Progressivo: this.prog,
          Num_Ord: this.numOrdine,
          Riferimento: this.rif
        };
        await save_confermeOrdini(par);
        this.chiudi(true);
      } catch (err) {
        console.log(err);
      }

      this.attesa = false;
    },

    chiudi(aggiorna) {
      this.$emit("chiudiDialog", aggiorna);
    },

    esciDialogTermini() {
      this.dialogTermini = false;
    }
  },

  mounted() {
    this.caricaDati();
  },

  watch: {
    dialog() {
      this.caricaDati();
    }
  },

  computed: {
    getMail() {
      return this.$store.getters["user/getMail"];
    },

    getMsg() {
      if (this.fuoriTempo) {
        return "Data consegna da aggiornare, contattaci al 0173791110";
      } else if (this.confermato == false) {
        return " Dalla convalida della presente non verranno accettate successive modifiche all'ordine";
      } else if (this.confermato) {
        return " Ordine confermato";
      }

      return "";
    },

    visBottoneConferma() {
      if (this.confermato) return false;
      else if (this.fuoriTempo) return false;
      else if (this.role == "Agente" || this.role == "AgenteCapo") return false;
      else if (this.serie == "Ignis Manuello") return false;
      return true;
    }
  }
};
</script>

<style scoped>
@media screen and (max-width:512px) {
  .scroll-wrapper {
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

::-webkit-scrollbar {
  -webkit-appearance: none;
}

::-webkit-scrollbar:vertical {
  width: 12px;
}

::-webkit-scrollbar:horizontal {
  height: 12px;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, .5);
  border-radius: 10px;
  border: 2px solid #ffffff;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #ffffff;
}
</style>